var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcEmptyContent',{attrs:{"name":_vm.t('collectives', 'Page not found: {page}', { page: _vm.pageParam }),"description":_vm.t('collectives', 'Select a page from the list or create a new one.')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('PageIcon')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }